const comSecMain = (() => {

  const fadeElem = document.querySelectorAll('.js-com-sec-main');
  if (fadeElem.length > 0) {

    const text = new SplitType("#jsComTtl");/*テキストの分割*/
    const text2 = new SplitType("#jsComLead");/*テキストの分割*/

    gsap.to("#jsComSecMain .char", {
      y: 0 /*テキストのY軸の操作*/,
      stagger: 0.05 /*テキスト間の遅延時間*/,
      delay: 0.2 /*アニメーションのスタートまでの遅延時間*/,
      autoAlpha: 1,
      // duration: 0.5 /*アニメーションの時間*/,
      // ease: power2.out /*イージングの設定*/,
    });

  }

})();
export default comSecMain;